import { IState } from 'legacy/lut/store'

export const selectBasicInfoState = (state: IState) => state.partner360.basicInfo
